export const horizontalClass = 'empty-state--horizontal';
